import { createRegistry } from './registry';

export default createRegistry();
